package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.create_product_ingredients


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("createProductIngredient")
    val createProductIngredient: CreateProductIngredient?,
    @SerialName("__typename")
    val typename: String?
)